import { render, staticRenderFns } from "./ProjectTemplate.vue?vue&type=template&id=462bb0bf&scoped=true&"
import script from "./ProjectTemplate.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplate.vue?vue&type=style&index=0&id=462bb0bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462bb0bf",
  null
  
)

export default component.exports